import { render, staticRenderFns } from "./AffixforRight.vue?vue&type=template&id=3fd3eb25&"
import script from "./AffixforRight.vue?vue&type=script&lang=js&"
export * from "./AffixforRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports